module.exports = __webpack_public_path__ + "static/imageOurCulture-bb6c0daaeec374ada4dd0efd1b7bc8f2.png";